import { useSelector } from "react-redux";
import NoAuthModal from "@components/Modals/NoAuthModal";
import { useKeycloak } from "@react-keycloak/web";

const PrivateRoute = ({ element: Component, ...rest }) => {
  const { initialized } = useKeycloak();
  const isAuthenticated = useSelector((state) => state.auth.status);

  if (!initialized) return null;

  if (!isAuthenticated) {
    return <NoAuthModal />;
  }

  return <Component {...rest} />;
};

export default PrivateRoute;
